class MainNavigationErsteEbene extends HTMLElement {
    constructor() {
        super();
        this.kategorieOverlayAnimationDuration = 0;
        this.overlay = this.querySelector('DIALOG');
        this.buttonOpenNaviDialog = this.querySelector('.open-navi-overlay');
        this.slider = this.querySelector('.item-list--desktop');
        this.sliderItems = this.querySelectorAll('.item');
        this.controls = this.querySelector('.controls');
        this.next = this.querySelector('.next');
        this.prev = this.querySelector('.prev');
        this.kategorieButtons = this.querySelectorAll('.kategorie-button');
        this.initListener();
        this.controls.setAttribute('active', '');
        this.initControlObservers();
    }

    connectedCallback() {
    }

    static get observedAttributes() {
        return ['open-overlay'];
    }

    attributeChangedCallback(name, oldval, newval) {
        if (name === 'open-overlay') {
            this.overlayOeffnen();
        }
    }

    disconnectedCallback() {
        this.removeListener();
    }

    initListener() {
        this.overlayOeffnenHandler = this.overlayOeffnen.bind(this);
        this.buttonOpenNaviDialog.addEventListener('click', this.overlayOeffnenHandler);
        this.scrollNextHandler = this.scrollNext.bind(this);
        this.scrollPrevHandler = this.scrollPrev.bind(this);
        this.next.addEventListener('click', this.scrollNextHandler);
        this.prev.addEventListener('click', this.scrollPrevHandler);
        this.kategorieButtons.forEach(button => {
            button.addEventListener('click', () => {
                const katToolId = button.dataset.katToolId;
                this.loadAndOpenOverlayForKategorie(katToolId, true);
            });
        });
    }

    removeListener() {
        this.buttonOpenNaviDialog.removeEventListener('click', this.overlayOeffnenHandler);
        this.next.removeEventListener('click', this.scrollNextHandler);
        this.prev.removeEventListener('click', this.scrollPrevHandler);
    }

    overlayOeffnen() {
        this.overlayObersteEbeneOeffnen(false);
    }

    overlayObersteEbeneOeffnen(skipAnimation) {
        this.overlay.dataset.animation = skipAnimation ? 'skip' : 'default';
        this.overlay.showModal();
    }

    overlaySchliessen() {
        this.overlay.close();
    }

    scrollNext() {
        const nextItem = this.getNextVisibleItem();
        this.scrollToPosition(nextItem.offsetLeft);
    }

    scrollPrev() {
        const prevItem = this.getPrevVisibleItem();
        if (prevItem) {
            // Berechne die Position, um das Element am *rechten* Rand des Containers zu positionieren.
            const containerWidth = this.slider.offsetWidth;
            const itemWidth = prevItem.offsetWidth;
            const scrollPosition = prevItem.offsetLeft + itemWidth - containerWidth;

            // Stelle sicher, dass wir nicht negativ scrollen.
            this.scrollToPosition(Math.max(0, scrollPosition));
        }
    }

    getNextVisibleItem() {
        const containerRect = this.slider.getBoundingClientRect();
        const items = Array.from(this.sliderItems);

        for (let item of items) {
            const itemRect = item.getBoundingClientRect();

            if (itemRect.right > containerRect.right) {
                return item;
            }
        }

        return items[items.length - 1];
    }

    getPrevVisibleItem() {
        const containerRect = this.slider.getBoundingClientRect();
        const items = Array.from(this.sliderItems);
        let lastVisibleItem = null;

        for (let i = items.length - 1; i >= 0; i--) {
            const item = items[i];
            const itemRect = item.getBoundingClientRect();

            if (itemRect.left < containerRect.right) {
                if (itemRect.left < containerRect.left) {
                    return item;
                } else if (!lastVisibleItem) {
                    lastVisibleItem = item;
                }
            }
        }

        if (lastVisibleItem) {
            const index = items.indexOf(lastVisibleItem);
            if (index > 0) {
                return items[index - 1];
            }
        }

        return items[0];
    }

    scrollToPosition(x) {
        this.slider.scrollTo({
            top: 0,
            left: x,
            behavior: 'smooth',
        });
    }

    initControlObservers() {
        this.sliderItemFirst = this.slider.querySelector('.item:first-of-type');
        this.sliderItemLast = this.slider.querySelector('.item:last-of-type');
        this.options = {
            root: this,
            threshold: [0.8, 1],
        };
        this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                this.intersectionHandler(entry);
            });
        }, this.options);
        this.observer.observe(this.sliderItemFirst);
        this.observer.observe(this.sliderItemLast);
    }

    intersectionHandler(entry) {
        let control = null;
        if (entry.target === this.sliderItemFirst) {
            control = this.prev;
        }
        if (entry.target === this.sliderItemLast) {
            control = this.next;
        }
        if (control) {
            if (entry.isIntersecting && entry.intersectionRatio >= 1) {
                control.style.display = 'none';
            } else {
                control.style.display = 'inline-flex';
            }
        }
    }

    // Lädt den Drilldown-Endpunkt für eine Kategorie der ersten Ebene und öffnet das Overlay.
    // Verbindet sich mit dem bestehenden MainNavigationIncludeController
    // (/navigation/include/main-navigation/kategorie/{katToolId}).
    // Im Storybook ohne laufenden Server nicht funktional — bekannte Einschränkung für diesen Schritt.
    loadAndOpenOverlayForKategorie(katToolId, skipAnimation) {
        if (!katToolId) {
            console.error('Kategorie-ID is missing');
            return;
        }

        document.querySelectorAll('[component="main-navigation-kategorien"]:not([data-head-only="true"])')
            .forEach(mainNavigationKategorien => {
                mainNavigationKategorien.remove();
            });

        const url = `/navigation/include/main-navigation/kategorie/${katToolId}?open-overlay=true&skip-animation=${skipAnimation}`;

        fetch(url)
            .then(response => {
                if (!response.ok) {
                    throw response;
                }
                return response.text();
            })
            .then(htmlText => this.onKategorieOverlayReceived(htmlText))
            .then(() => setTimeout(this.overlaySchliessen.bind(this), this.kategorieOverlayAnimationDuration))
            .catch(error => {
                console.error(error);
            });
    }

    onKategorieOverlayReceived(htmlText) {
        const range = document.createRange();
        range.selectNode(this);
        this.after(range.createContextualFragment(htmlText));
    }

}

if (!customElements.get('main-navigation-erste-ebene')) {
    customElements.define('main-navigation-erste-ebene', MainNavigationErsteEbene);
}
